import React from 'react';
//import {authRoles} from '../../auth';

export const UserGroupListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth : ['rh', 'rh_not_signer'],
    routes  : [
        {
            path     : '/sucursales-list',
            component: React.lazy(() => import('./UserGroupList'))
        }
    ]
};